import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import React from 'react';

interface AIDescriptionChatContextProps {
  selectedText: string;
  onClear: () => void;
}

export const AIDescriptionChatContext: React.FC<AIDescriptionChatContextProps> = ({ selectedText, onClear }) => {
  if (!selectedText || !selectedText.trim()) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 p-3 bg-neutral-200 border border-neutral-300 rounded-lg mx-3 my-2 relative">
      <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-neutral-900">
        <ArrowRightOutlined />
      </div>
      <div className="flex-1 text-sm leading-4 text-neutral-900 overflow-hidden line-clamp-2 break-words">
        {selectedText}
      </div>
      <button
        className="flex-shrink-0 w-5 h-5 flex items-center justify-center p-0.5 border-0 bg-transparent text-neutral-900 cursor-pointer rounded transition-all hover:bg-neutral-300 hover:text-brand-grey-dark active:scale-95"
        onClick={onClear}
        type="button"
        aria-label="Clear selection"
      >
        <CloseOutlined />
      </button>
    </div>
  );
};
